module.exports = __webpack_public_path__ + "img/qistina.524c9107.jpeg";